import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import './AnalyzeSources.css'
import {
  CSRD_EXPERT,
  skolansKvalitetscoachPrompt,
  support_prompt,
  INFOSEC_EXPERT,
  ARBETSMILJO_COACHEN,
  KVALITETS_PATIENTSAKERHETS_COACHEN
} from './prompts.js'
import { all } from 'axios'

// Endpoints dictionary for API calls
const endpoints = {
  'bot.dev.stratsys.net': 'https://data-ai-insights.svc.dev.stratsys.net',
  'bot.test.stratsys.net': 'https://data-ai-insights.svc.test.stratsys.net',
  'bot.stratsys.com': 'https://data-ai-insights.svc.stratsys.com',
  'localhost:8080': 'http://localhost:5001'
}

// Parsing function to extract title, url, and content from each source result.
const parseResult = (result) => {
  const lines = result.split('\n')
  let title = ''
  let url = ''
  let content = ''

  if (lines.length > 0 && lines[0].startsWith('Chunk:')) {
    title = lines[0].replace('Chunk title:', '').trim()
    console.log('Title:', title)
  }
  if (lines.length > 1 && lines[1].startsWith('Url source:')) {
    url = lines[1].replace('Url source:', '').trim()
  }
  // The remaining lines will be the main content
  content = lines.slice(2).join('\n')
  return { title, url, content }
}

// Component to display a single source result card.
const SourceCard = ({ result }) => {
  let title = result.title
  let url = result.url
  let content = result.content
  return (
    <div className="AS-card">
      <div className="AS-card-header">
        <h3 className="AS-card-title">{title}</h3>
        {url && (
          <a className="AS-card-url" href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </a>
        )}
      </div>
      <ReactMarkdown className="AS-card-content">{content}</ReactMarkdown>
    </div>
  )
}

// Component to display a single LLM answer card.
const AnswerCard = ({ answer, sourceIndex, prompt }) => {
  return (
    <div className="AS-card">
      <div className="AS-card-header">
        <h3 className="AS-card-title">
          LLM Answer: {sourceIndex} with {prompt} prompt
        </h3>
      </div>
      <ReactMarkdown className="AS-card-content">{answer}</ReactMarkdown>
    </div>
  )
}

const AnalyzeSources = () => {
  const prompt_dict = [
    {
      value: 'Standard Support',
      text: 'Standard Support',
      prompt: support_prompt
    },
    {
      value: 'Skolans Kvalitetscoach',
      text: 'Skolans Kvalitetscoach',
      prompt: skolansKvalitetscoachPrompt
    },
    {
      value: 'CSRD Expert',
      text: 'CSRD Expert',
      prompt: CSRD_EXPERT
    },
    {
      value: 'INFOSEC Expert',
      text: 'INFOSEC Expert',
      prompt: INFOSEC_EXPERT
    },
    {
      value: 'Arbetsmiljöcoachen',
      text: 'Arbetsmiljöcoachen',
      prompt: ARBETSMILJO_COACHEN
    },
    {
      value: 'Kvalitets- och patientsäkerhetscoachen',
      text: 'Kvalitets- och patientsäkerhetscoachen',
      prompt: KVALITETS_PATIENTSAKERHETS_COACHEN
    },
    {
      value: 'Custom',
      text: 'Custom',
      prompt: ''
    }
  ]
  const getTextFromValue = (value) => {
    const item = index_dict.find((item) => item.value === value[0])
    console.log('Item:', item)
    return item ? item.text : 'Unknown' // Fallback if not found
  }

  const getPromptFromValue = (value) => {
    const item = prompt_dict.find((item) => item.value === value[0])
    console.log('Item:', item)
    return item ? item.prompt : 'Unknown' // Fallback if not found
  }

  const [query, setQuery] = useState('')
  const [index1, setIndex1] = useState(['stratsys-support-index'])
  const [index2, setIndex2] = useState(['stratsys-contextual-index'])
  const [topk1, setTopk1] = useState(8)
  const [topk2, setTopk2] = useState(8)
  const [sortChunks1, setSortChunks1] = useState(false)
  const [sortChunks2, setSortChunks2] = useState(false)
  const [fetchedData, setFetchedData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [answerData, setAnswerData] = useState(null)
  const [answerLoading, setAnswerLoading] = useState(false)
  const [prompt1, setPrompt1] = useState(['Standard Support'])
  const [prompt2, setPrompt2] = useState(['Standard Support'])

  const [editingPrompt1, setEditingPrompt1] = useState(false)
  const [editingPrompt2, setEditingPrompt2] = useState(false)
  const [specificPrompt1, setSpecificPrompt1] = useState(getPromptFromValue(prompt1))
  const [specificPrompt2, setSpecificPrompt2] = useState(getPromptFromValue(prompt2))

  const index_dict = [
    { value: 'stratsys-support-index', text: 'Stratsys Support External' },
    { value: 'stratsys-contextual-index', text: 'Contextual Support External' },
    { value: 'support-index', text: 'Stratsys Support Internal' },
    { value: 'translation-index', text: 'Stratsys Translations' },
    { value: 'contextual-infosec-index', text: 'Contextual Information Security' },
    { value: 'contextual-sustainability-index', text: 'Contextual Sustainability' },
    { value: 'contextual-csrd-guidlines-index', text: 'Contextual CSRD Guidelines' },
    { value: 'contextual-csrd-laws-index', text: 'Contextual CSRD Legal Requirements' },
    { value: 'contextual-ghg-index', text: 'Contextual Greenhouse Gas (GHG) Emissions Reporting' },
    { value: 'sustainability-csrd-guidelines-index', text: 'CSRD Sustainability Guidelines' },
    { value: 'sustainability-csrd-laws-index', text: 'CSRD Legal Requirements' },
    { value: 'sustainability-ghg-index', text: 'Greenhouse Gas (GHG) Emissions Reporting' },
    { value: 'contextual-ska-nks-index', text: 'Contextual SKA/NKS' },

    { value: 'information-security-aicpa-soc-index', text: 'AICPA SOC Information Security' },
    {
      value: 'information-security-cloud-security-alliance-ccm-caiq-index',
      text: 'Cloud Security Alliance CCM & CAIQ'
    },
    { value: 'information-security-iso-index', text: 'ISO Information Security' },
    { value: 'information-security-cmmc-index', text: 'Cybersecurity Maturity Model Certification (CMMC)' },
    { value: 'information-security-laws-eu-index', text: 'EU Information Security Laws' },
    { value: 'information-security-laws-swe-index', text: 'Swedish Information Security Laws' },
    { value: 'information-security-laws-no-index', text: 'Norwegian Information Security Laws' },
    { value: 'information-security-nist-index', text: 'NIST Cybersecurity Framework' },
    { value: 'information-security-cis-index', text: 'CIS Cybersecurity Controls' },

    { value: 'sam-afs-index', text: 'Systematic Work Environment Management (AFS)' },
    { value: 'qmhc-sosfs20119-index', text: 'Swedish Healthcare Quality (SOSFS 2011:9)' },
    { value: 'stratsys-support-resource-planning-index', text: 'Stratsys Resource Planning (RP)' },
    { value: 'ska-nks-index', text: 'Swedish Education Quality Management (SKA & NKS)' },

    { value: 'contextual-aipa-soc-index', text: 'Contextual AICPA SOC' },
    { value: 'contextual-cis-index', text: 'Contextual CIS Cybersecurity Controls' },
    {
      value: 'contextual-cloud-security-alliance-ccm-caiq-index',
      text: 'Contextual Cloud Security Alliance CCM & CAIQ'
    },
    { value: 'contextual-cmmc-index', text: 'Contextual Cybersecurity Maturity Model Certification (CMMC)' },
    { value: 'contextual-laws-eu-index', text: 'Contextual EU Laws' },
    { value: 'contextual-nist-index', text: 'Contextual NIST Cybersecurity Framework' },
    { value: 'contextual-qmhc-index', text: 'Contextual Quality Management in Healthcare' },
    { value: 'contextual-sam-index', text: 'Contextual Systematic Work Environment Management' },
    { value: 'contextual-iso-index', text: 'Contextual ISO Information Security' }
  ]

  const handleChangePrompt1 = (e) => {
    console.log(prompt_dict)
    setPrompt1(e.target.value)
    let p = getPromptFromValue(e.target.value)
    setSpecificPrompt1(p)
  }

  const handleChangePrompt2 = (e) => {
    setPrompt2(e.target.value)
    let p = getPromptFromValue(e.target.value)
    setSpecificPrompt2(p)
  }

  const handleIndex1Change = (e) => {
    setIndex1(e.target.value)
    setFetchedData(null) // Clear any previous results
    setAnswerData(null) // Clear any previous answers
  }

  const handleIndex2Change = (e) => {
    setIndex2(e.target.value)
    setFetchedData(null) // Clear any previous results
    setAnswerData(null) // Clear any previous answers
  }

  const handleFetchData = async () => {
    setLoading(true)
    setFetchedData(null)
    setAnswerData(null) // Clear any previous answers
    try {
      const response = await window.PDR.api.post(`${endpoints[window.location.host]}/analyze_sources`, {
        query,
        index1,
        index2,
        topk1,
        topk2,
        sort_chunks1: sortChunks1,
        sort_chunks2: sortChunks2
      })
      // Parse response if needed
      let data
      if (typeof response === 'string') {
        try {
          data = JSON.parse(response)
        } catch (parseError) {
          console.error('Error parsing response:', parseError)
          data = {}
        }
      } else {
        data = response
      }
      setFetchedData(data)
    } catch (error) {
      console.error('Error fetching sources:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleAnswer = async () => {
    setAnswerLoading(true)
    setAnswerData(null)
    try {
      const response = await window.PDR.api.post(`${endpoints[window.location.host]}/analyze_query`, {
        query,
        sources1: fetchedData.results1,
        sources2: fetchedData.results2,
        prompt1: specificPrompt1,
        prompt2: specificPrompt2
      })
      let data
      if (typeof response === 'string') {
        try {
          data = JSON.parse(response)
        } catch (err) {
          console.error('Error parsing LLM answer response:', err)
          data = {}
        }
      } else {
        data = response
      }
      setAnswerData(data)
    } catch (error) {
      console.error('Error fetching LLM answer:', error)
    } finally {
      setAnswerLoading(false)
    }
  }

  // Allow search to trigger on Enter key press
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleFetchData()
    }
  }

  const formatSources = (sources) => {
    if (!sources || !Array.isArray(sources)) return ''
    return sources.map((s) => `${s.title}${s.url ? ' (' + s.url + ')' : ''}`).join(' | ')
  }

  const handleCopy = (columnNumber) => {
    const queryText = query.replace(/\t|\n/g, ' ') || ''
    const indexText = columnNumber === 1 ? getTextFromValue(index1) : getTextFromValue(index2)
    const sourcesText =
      columnNumber === 1
        ? fetchedData?.results1
          ? formatSources(fetchedData.results1)
          : ''
        : fetchedData?.results2
          ? formatSources(fetchedData.results2)
          : ''
    const promptText = columnNumber === 1 ? prompt1[0].replace(/\t|\n/g, ' ') : prompt2[0].replace(/\t|\n/g, ' ')
    const answerText =
      columnNumber === 1
        ? answerData?.results1.replace(/\t|\n/g, ' ') || ''
        : answerData?.results2.replace(/\t|\n/g, ' ') || ''

    // Use tab (`\t`) as the delimiter
    const textToCopy = `${queryText}\t${indexText}\t${sourcesText}\t${promptText}\t${answerText}\t...`

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        alert('Copied to clipboard!')
      })
      .catch((err) => {
        alert('Failed to copy!')
        console.error(err)
      })
  }

  const handleMultipleIndexSearch = async () => {
    const allIndexes = index_dict.map((item) => item.value)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/multiple_sources_async`, {
      query,
      indexes: ['stratsys-support-index', 'contextual-csrd-guidlines-index', 'sustainability-csrd-guidelines-index'] //allIndexes
    })
    console.log('Multiple Indexes Response:', response)
  }

  return (
    <div className="AS-analyze-sources-container">
      <h1 className="AS-title">Stratsys Source Analyzer</h1>
      <div className="AS-search-section">
        <div className="AS-main-search">
          <textarea
            placeholder="Enter your query..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button onClick={handleFetchData}>Search</button>
          {/* <button onClick={handleMultipleIndexSearch}>Multiple Index Search</button> */}
        </div>
        {/* All filters arranged horizontally in one row */}
        <div className="AS-filters">
          <div className="AS-filter-item">
            <label>Sort Chunks 1:</label>
            <label className="AS-switch">
              <input type="checkbox" checked={sortChunks1} onChange={(e) => setSortChunks1(e.target.checked)} />
              <span className="AS-slider"></span>
            </label>
          </div>
          <div className="AS-filter-item">
            <label>TopK 1:</label>
            <input
              type="number"
              value={topk1}
              onChange={(e) => {
                const value = Number(e.target.value)
                if (value >= 0) {
                  setTopk1(value)
                } else {
                  setTopk1(0) // Optionally reset to 0 if negative input is attempted
                }
              }}
              min="0" // This prevents decrementing below 0 with the arrow buttons
            />
          </div>
          <one-ux-field label="Index 1" width="2/12">
            <one-ux-dropdown>
              <one-ux-list options={index_dict} value={index1} onInput={handleIndex1Change}></one-ux-list>
            </one-ux-dropdown>
          </one-ux-field>
          <one-ux-field label="Index 2" width="2/12">
            <one-ux-dropdown placeholder={'Value'}>
              <one-ux-list options={index_dict} value={index2} onInput={handleIndex2Change}></one-ux-list>
            </one-ux-dropdown>
          </one-ux-field>
          <div className="AS-filter-item">
            <label>TopK 2:</label>
            <input
              type="number"
              value={topk2}
              onChange={(e) => {
                const value = Number(e.target.value)
                if (value >= 0) {
                  setTopk2(value)
                } else {
                  setTopk2(0) // Optionally reset to 0 if negative input is attempted
                }
              }}
              min="0" // This prevents decrementing below 0 with the arrow buttons
            />
          </div>
          <div className="AS-filter-item">
            <label>Sort Chunks 2:</label>
            <label className="AS-switch">
              <input type="checkbox" checked={sortChunks2} onChange={(e) => setSortChunks2(e.target.checked)} />
              <span className="AS-slider"></span>
            </label>
          </div>
        </div>
      </div>

      {loading && (
        <div className="AS-loading-spinner">
          <div className="AS-spinner"></div>
        </div>
      )}

      {fetchedData && (
        <>
          <div className="AS-answer-section">
            {editingPrompt1 && (
              <textarea
                className="edit-prompt-textarea"
                value={specificPrompt1}
                onChange={(e) => setSpecificPrompt1(e.target.value)}
                placeholder="Edit your prompt here..."
              />
            )}
            <div className="AS-edit-icon">
              <one-ux-button label="Edit prompt" onClick={() => setEditingPrompt1(!editingPrompt1)}>
                <one-ux-icon icon="edit"></one-ux-icon>
              </one-ux-button>
            </div>

            <one-ux-field label="Prompt 1" width="2/12">
              <one-ux-dropdown>
                <one-ux-list options={prompt_dict} value={prompt1} onInput={handleChangePrompt1}></one-ux-list>
              </one-ux-dropdown>
            </one-ux-field>

            <button className="AS-answer-button" onClick={handleAnswer}>
              Answer with LLM
            </button>
            <one-ux-field label="Prompt 2" width="2/12">
              <one-ux-dropdown>
                <one-ux-list options={prompt_dict} value={prompt2} onInput={handleChangePrompt2}></one-ux-list>
              </one-ux-dropdown>
            </one-ux-field>
            <div className="AS-edit-icon">
              <one-ux-button label="Edit prompt" onClick={() => setEditingPrompt2(!editingPrompt2)}>
                <one-ux-icon icon="edit"></one-ux-icon>
              </one-ux-button>
            </div>
            {editingPrompt2 && (
              <textarea
                className="edit-prompt-textarea"
                value={specificPrompt2}
                onChange={(e) => setSpecificPrompt2(e.target.value)}
                placeholder="Edit your prompt here..."
              />
            )}
          </div>
          {answerLoading && (
            <div className="AS-loading-spinner">
              <div className="AS-spinner"></div>
            </div>
          )}
          {answerData && (
            <div className="AS-answers-container">
              <one-ux-button label="Copy" onClick={() => handleCopy(1)}>
                <one-ux-icon icon="copy"></one-ux-icon>
              </one-ux-button>
              <div className="AS-answer-column">
                <AnswerCard answer={answerData.results1} sourceIndex={getTextFromValue(index1)} prompt={prompt1} />
              </div>
              <div className="AS-answer-column">
                <AnswerCard answer={answerData.results2} sourceIndex={getTextFromValue(index2)} prompt={prompt2} />
              </div>
              <one-ux-button label="Copy" onClick={() => handleCopy(2)}>
                <one-ux-icon icon="copy"></one-ux-icon>
              </one-ux-button>
            </div>
          )}

          <div className="AS-cards-container">
            <div className="AS-card-column">
              <h2>{getTextFromValue(index1)}</h2>
              {fetchedData.results1.map((result, idx) => (
                <SourceCard key={`results1 - ${idx}`} result={result} />
              ))}
            </div>
            <div className="AS-card-column">
              <h2>{getTextFromValue(index2)}</h2>
              {fetchedData.results2.map((result, idx) => (
                <SourceCard key={`results2 - ${idx}`} result={result} />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default AnalyzeSources
